import React from "react";
import SingleTrainer from "components/single-trainer";
import RichText from "components/rich-text";

const OurTrainers = ({ data }) => {
  const components = {
    normal: ({ children }) => <p className="sm:inline">{children}</p>,
  };

  return (
    <div className="container">
      <div className="py-0.5 flex flex-col justify-center items-center text-white">
        <h1 className="text-[42px] font-bold text-center text-green-800 font-display">
          {data.title}
        </h1>
        <div className="text-base text-gray-600 text-center">
          <RichText data={data.description} components={components} />
        </div>
      </div>
      <div className="mt-16">
        {data.trainers.map((trainer, index) => {
          if (trainer) return <SingleTrainer key={index} trainer={trainer} />;
        })}
      </div>
    </div>
  );
};

export default OurTrainers;
